export default "__VITE_ASSET__BaH14Rd1__"